module.exports = __webpack_public_path__ + "static/img/brand-yidao.29030a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand-yidao.jpg
// module id = o9gt
// module chunks = 3